import { css } from "@emotion/react";
import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import {
	colors,
	RiCameraLine,
	RiListCheck3,
	RiStickyNoteLine
} from "@itandi/itandi-bb-ui";
import { Text } from "@itandi/itandi-bb-ui/Text";
import type { ComponentProps } from "react";

type Variant = "Memo" | "Todo" | "Image";

type Props = DeepReadonly<{
	count: number;
	onClick: ComponentProps<"button">["onClick"];
	variant: Variant;
}>;

const Icons = {
	Image: RiCameraLine,
	Memo: RiStickyNoteLine,
	Todo: RiListCheck3
};

/**
  @deprecated 削除したい場合は相談ワークフローからデザインの修正を依頼してください（新しい画面では使わないでください）
 */
export function ContentCounter({ count, onClick, variant }: Props) {
	const Icon = Icons[variant];

	return (
		<button
			css={css({
				"&:hover": {
					background: colors["gray-100"]
				},
				alignItems: "center",
				background: colors["itandi-white"],
				border: `1px solid ${colors["gray-300"]}`,
				borderRadius: 12,
				display: "flex",
				gap: 2,
				height: 24,
				justifyContent: "center",
				padding: "0 8px"
			})}
			onClick={onClick}
			type="button"
		>
			<Icon
				css={css({
					color: colors["semantic-link"],
					height: 14,
					minWidth: 14,
					width: "100%"
				})}
			/>
			{count > 0 ? (
				<Text leading="Tight" size="S">
					{count}
				</Text>
			) : null}
		</button>
	);
}
